<div class="search">
  <app-search-field
    placeholder="Search website or group"
    (searchText)="onSearch($event)"
  ></app-search-field>
</div>

<div class="websites">
  <div class="row">
    <h2>Recently added websites</h2>
    <button matButton="filled" class="app-btn-small" (click)="addWebsite()">
      <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
      Add Website
    </button>
  </div>

  <mat-card appearance="outlined" class="table-container">
    @if (websites$ | async; as websites) {
      <app-table
        [columns]="websiteColumns"
        [dataSource]="websites"
        [totalCount]="totalWebsites()"
        (pageChange)="handleWPageEvent($event)"
      >
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <app-status-label [status]="element.status"></app-status-label>
          </td>
        </ng-container>

        <ng-container matColumnDef="buttons">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let element">
            <div
              matRipple
              class="button"
              matTooltip="Manage website, install ssl, manage php, cdn and others."
              [matTooltipShowDelay]="500"
              matTooltipPosition="above"
              [routerLink]="['/overview', element.id]"
            >
              <fa-icon [icon]="['fas', 'arrow-right']" size="lg"></fa-icon>
            </div>
          </td>
        </ng-container>
      </app-table>
    }
  </mat-card>
</div>

<div class="groups">
  <div class="row">
    <h2>Recently added groups</h2>
  </div>

  <mat-card appearance="outlined" class="table-container">
    @if (groups$ | async; as groups) {
      <app-table
        [columns]="groupsColumns"
        [dataSource]="groups"
        [totalCount]="totalGroups()"
        (pageChange)="handleGPageEvent($event)"
      >
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            @if (element.website?.status; as status) {
              <app-status-label [status]="status"></app-status-label>
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="buttons">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div
              matRipple
              class="button"
              matTooltip="Manage Website group - suspend/unsuspend, add sites, and etc."
              [matTooltipShowDelay]="500"
              matTooltipPosition="above"
              [routerLink]="['/group', element.id]"
            >
              <fa-icon [icon]="['fas', 'arrow-right']" size="lg"></fa-icon>
            </div>
          </td>
        </ng-container>
      </app-table>
    }
  </mat-card>
</div>
